import { useSelector } from 'react-redux'

export const useIsPremium = () => {
  const { authenticated, currentUser, premiumHistory, isSharePremium } =
    useSelector(state => state.auth)

  return {
    isPremium: !!authenticated && currentUser?.isPremium,
    currentUser,
    premiumHistory,
    isSharePremium,
  }
}
